class HeaderMegamenu extends HTMLElement {
  constructor() {
    'use strict';
    super();

    this.el = this;
    this.button = this.closest('.header-shortlink--hook').querySelector('button');
    this.button.addEventListener('click', this.toggleMenuItemFromTheme.bind(this));

    /**
     * When  document.dispatchEvent(new CustomEvent('woolman:sticky-header-hide')); is called,
     * remove is-open class from the megamenu.
     */

    document.addEventListener('woolman:sticky-header-hide', function () {
      this.toggleMenuItemFromTheme(null, true);
    }.bind(this));

    /**
     * Observer for 'is-open' class changes to bind/unbind related events.
     */
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('is-open')) {
            // bind click outside
            // bind escape deactivate
            document.addEventListener('click', this.closeMenu.bind(this));
            document.addEventListener('keydown', this.closeMenu.bind(this));
          } else {
            // unbind click outside
            // unbind escape deactivate
            document.removeEventListener('click', this.closeMenu.bind(this));
            document.removeEventListener('keydown', this.closeMenu.bind(this));
          }
        }
      });
    });
    observer.observe(this.el, { attributes: true });
  }

  toggleMenuItemFromTheme(evt, forceClose = false) {
    if (forceClose === true) {
      this.el.classList.remove('is-open');
    } else {
      this.el.classList.toggle('is-open');
    }
  }

  // click outside & escape deactivate
  closeMenu(evt) {
    if (evt.type === 'click') {
      if (!this.el.contains(evt.target) && !this.button.contains(evt.target)) {
        this.el.classList.remove('is-open');
        document.removeEventListener('click', this.closeMenu.bind(this));
      }
    }

    if (evt.type === 'keydown') {
      if (evt.key === 'Escape') {
        this.el.classList.remove('is-open');
        document.removeEventListener('keydown', this.closeMenu.bind(this));
      }
    }
  }
}

if (customElements.get('header-megamenu') === undefined) {
  customElements.define('header-megamenu', HeaderMegamenu);
}